import React from 'react';
import {
  Breadcrumb, BreadcrumbItem, Card, CardBody, CardFooter, CardHeader,
} from 'reactstrap';

const BREADCRUMB_WIDTHS = ['3rem', '5.5rem', '8rem', '6rem'];

/**
 * Skeleton placeholder for admin form routes (AdminPortfolioEdit, AdminPortfolioRetire, etc.).
 * Mirrors the shared admin form layout — a breadcrumb ending in the form name,
 * then a single card with a heading, one labelled field and a submit button —
 * shown when a field or network error on the route query is caught by
 * PlaceholderErrorBoundary.
 * @returns {React.ReactElement} AdminFormPlaceholder component.
 */
function AdminFormPlaceholder() {
  return (
    <div aria-hidden="true" data-testid="admin-form-placeholder">
      <Breadcrumb>
        {BREADCRUMB_WIDTHS.map((width) => (
          <BreadcrumbItem key={width}>
            <span className="placeholder placeholder-glow bg-darken" style={{ width }} />
          </BreadcrumbItem>
        ))}
      </Breadcrumb>

      <Card>
        <CardHeader>
          <h2>
            <span className="placeholder placeholder-glow bg-darken col-3" />
          </h2>
          <span className="placeholder placeholder-glow bg-darken col-5" />
        </CardHeader>
        <CardBody>
          <span className="placeholder placeholder-glow bg-darken col-1 mb-2" />
          <span className="placeholder placeholder-glow bg-darken form-control mb-1" />
          <span className="placeholder placeholder-glow bg-darken placeholder-sm col-4" />
        </CardBody>
        <CardFooter>
          <span className="placeholder placeholder-glow bg-darken btn" style={{ width: '12rem' }} />
        </CardFooter>
      </Card>
    </div>
  );
}

export default AdminFormPlaceholder;
